/**
 * 素材库 taxonomy code 常量
 *
 * 不同的 code 代表不同类型的素材分类体系，
 * 作为 POST /taxonomy 接口的请求参数。
 */
export const API_TAXONOMY_CODES = {
  /** HIFIVE 可商用背景音乐 */
  BGM: 'ykhg8z3y29'
} as const;

/**
 * 文件保存路径是，文件的存放的路径
 */
export const FILE_SAVE_FOLDER = 'resources/extfile';

/** 字体下载基础 URL */
export const FONT_DOWNLOAD_BASE_URL = 'https://book.yunzhan365.com/resourceFiles/editor/fonts/';
/** 字体缩略图基础 URL */
export const FONT_THUMB_BASE_URL = 'https://book.yunzhan365.com/resourceFiles/editor/fontimage/';
